import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { RecordingsStatus } from '../../../api/meetings.dao';
import Text from '../text/text';
import { Permission } from '../../../api/roles.dao';
import { hasPermission } from '../../../infrastructure/utils/has-permissions';
import DefaultButton from '../default-button/default-button';

import './meeting-guidelines.scss';
import { ISubWindowFacade, SubWindowStatus } from '../../../infrastructure/sub-windows';

export interface IProps {
    content: string;
    isExpanded: boolean;
    meetingRecordEnabled: boolean;
    showEventNotesPopup: (isEditMode: boolean) => void;
    isEventNotesExist: boolean;
    guidelinesFormSubWindow: { [key: string]: ISubWindowFacade };
}

const MeetingGuidelines = (props: IProps) => {
    const {
        content,
        isExpanded,
        meetingRecordEnabled,
        showEventNotesPopup,
        isEventNotesExist,
        guidelinesFormSubWindow,
    } = props;

    return (
        <div
            className={classNames('oe-form-field',
                { 'meeting-guidelines': content, 'meeting-guidelines__expanded': isExpanded })
            }
        >
            <div className={classNames('meeting-guidelines__recordings',
                {
                    'meeting-guidelines__recordings--wrap': !isExpanded,
                    'meeting-guidelines__recordings--content': content,
                })}
            >
                <div className={classNames('recordings-icon', { 'recordings-icon-active': meetingRecordEnabled })} />
                <Text
                    className='meeting-list-item__text'
                    message={`Record Meeting: ${meetingRecordEnabled ? RecordingsStatus.Yes : RecordingsStatus.No}`} withEllipsis />
                    {
                        hasPermission(Permission.VIEW_GUIDELINES) && isEventNotesExist && (
                            <div className={classNames('event-guidelines',
                                { 'event-guidelines--with-wrap': !isExpanded })}
                            >
                                <DefaultButton
                                    modifier={['fat', 'confirm-safe']}
                                    text={<FormattedMessage
                                        id='oe.control.viewEventGuidelines'
                                        defaultMessage='View Event Guidelines'
                                        description='View event guidelines'
                                    />}
                                    onClick={() => {
                                         if (!guidelinesFormSubWindow.edit || guidelinesFormSubWindow.edit.getStatus() === SubWindowStatus.Closed) {
                                            showEventNotesPopup(false);
                                        }
                                    }}
                                />
                            </div>
                        )
                    }
            </div>
            {content && <div>
                <div className='oe-form-field__title'>
                    <FormattedMessage
                        id='oe.meeting.meetingGuidelines'
                        description='Label text'
                        defaultMessage='Meeting Guidelines'
                    />
                </div>
                <div
                    className='meeting-guidelines__control'
                    dangerouslySetInnerHTML={{
                        __html: content
                    }}
                />
            </div>}
        </div>
    );
};

export default MeetingGuidelines;
